import React from 'react';
import { Pagination } from 'react-bootstrap';


interface PaginationComponentProps {
	currentPage: number;
	totalPages: number;
	hasNextPage: boolean;
	hasPreviousPage: boolean;
	nextPage: number | null;
	previousPage: number | null;
	onPaginate: (pageNumber: number) => void;
}

type PageToken = number | 'ellipsis';

const PaginationComponent: React.FC<PaginationComponentProps> = ({
	currentPage,
	totalPages,
	hasNextPage,
	hasPreviousPage,
	nextPage,
	previousPage,
	onPaginate
}) => {

	const getPageTokens = (): PageToken[] => {
		if (!totalPages || totalPages <= 0) return [];
		if (totalPages <= 7) return Array.from({ length: totalPages }, (_, i) => i + 1);

		const clampedCurrent = Math.min(Math.max(currentPage, 1), totalPages);
		const pages = new Set<number>();
		pages.add(1);
		pages.add(totalPages);

		if (clampedCurrent <= 4) {
			for (let p = 2; p <= 5; p++) pages.add(p);
		} else if (clampedCurrent >= totalPages - 3) {
			for (let p = totalPages - 4; p <= totalPages - 1; p++) pages.add(p);
		} else {
			for (let p = clampedCurrent - 1; p <= clampedCurrent + 1; p++) pages.add(p);
		}

		const sorted = Array.from(pages)
			.filter(p => p >= 1 && p <= totalPages)
			.sort((a, b) => a - b);

		const tokens: PageToken[] = [];
		for (let i = 0; i < sorted.length; i++) {
			const p = sorted[i];
			const prev = sorted[i - 1];
			if (i > 0 && p - prev > 1) tokens.push('ellipsis');
			tokens.push(p);
		}
		return tokens;
	};

	const pageTokens = getPageTokens();

	return (
		<>
			<Pagination className="justify-content-center">
				{/* <Pagination.First onClick={() => onPaginate(1)} disabled={!hasPreviousPage} /> */}
				<Pagination.Prev onClick={() => onPaginate(previousPage || 1)} disabled={!hasPreviousPage} />

				{pageTokens.map((token, idx) =>
					token === 'ellipsis' ? (
						<Pagination.Ellipsis key={`ellipsis-${idx}`} disabled />
					) : (
						<Pagination.Item
							key={token}
							active={token === currentPage}
							onClick={() => onPaginate(token)}
						>
							{token}
						</Pagination.Item>
					)
				)}

				<Pagination.Next onClick={() => onPaginate(nextPage || totalPages)} disabled={!hasNextPage} />
				{/* <Pagination.Last onClick={() => onPaginate(totalPages)} disabled={!hasNextPage} /> */}
			</Pagination>
		</>
	)
};

export default PaginationComponent;